import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import {
    Dumbbell,
    Hammer,
    Mic2,
    Music,
    Palette,
    PartyPopper,
    Sparkles,
    Users,
    UtensilsCrossed
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
    music: Music,
    nightlife: PartyPopper,
    conferences: Mic2,
    workshops: Hammer,
    'food-drink': UtensilsCrossed,
    arts: Palette,
    sports: Dumbbell,
    community: Users
}

interface CategoryIconProps {
    slug: string | null | undefined
    className?: string
}

export const CategoryIcon: FC<CategoryIconProps> = ({ slug, className }): ReactNode => {
    const Icon = (slug && ICONS[slug]) || Sparkles
    return <Icon className={className} aria-hidden='true' />
}
